import { render, staticRenderFns } from "./TvodAdvertisingOptIn.vue?vue&type=template&id=5c42527b&scoped=true&"
import script from "./TvodAdvertisingOptIn.vue?vue&type=script&lang=js&"
export * from "./TvodAdvertisingOptIn.vue?vue&type=script&lang=js&"
import style0 from "./TvodAdvertisingOptIn.vue?vue&type=style&index=0&id=5c42527b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c42527b",
  null
  
)

component.options.__file = "TvodAdvertisingOptIn.vue"
export default component.exports